import React, { FC } from "react";
import { Descriptions, Anchor } from "antd";
import "./EthBridgeInfo.scss";

const VLAUNCH_BLOCK_EXPLORER = process.env.REACT_APP_VLAUNCH_BLOCK_EXPLORER;

interface Props {
  from: string;
  amount: number;
  txHash: string;
  timestamp?: number;
}

export const ETHInfoTable: FC<Props> = ({ from, amount, txHash }) => {
  const { Link } = Anchor;
  return (
    <>
      <div className="table-size">
        <Descriptions
          column={{ xxl: 3, xl: 3, lg: 3, md: 3, sm: 3, xs: 3 }}
          bordered
        >
          <Descriptions.Item className="ETH-row-size" label="From">
            {from}
          </Descriptions.Item>
          <Descriptions.Item className="ETH-row-size" label="Amount">
            {amount}
          </Descriptions.Item>
          <Descriptions.Item className="ETH-row-size" label="Transaction Hash">
            <Anchor affix={false}>
              <Link
                href={`${VLAUNCH_BLOCK_EXPLORER}/tx/${txHash}`}
                title="Transaction Link"
                target="_blank"
              />
            </Anchor>
          </Descriptions.Item>
        </Descriptions>
      </div>
    </>
  );
};
